import { setSearchText } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
export default mutator(setSearchText, function (actionMessage) {
    getStore().searchText = actionMessage.searchText;
});
//# sourceMappingURL=setSearchTextMutator.js.map